import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { UpdateInventoryService } from 'common/data';

class UpdateInventoryStore extends BaseStore {
	constructor(rootStore) {
		super(new UpdateInventoryService(rootStore.app.baasic.apiClient));
	}

	@action
	findUpdateInventoryLog = async filter => {
		const response = await this.service.find(filter);
		if (filter && filter.search) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
		return response.data;
	};

	@action
	findGroupedInventoryLog = async filter => {
		const response = await this.service.findGroupedInventoryLog(filter);
		this.response = response.data;
		return response.data;
	};

	@action
	updateInventoryForProduct = async (productId, sourceOfChange) => {
		const response = await this.service.updateInventoryForProduct(productId, sourceOfChange);
		return response.data;
	};

	@action
	updateInventoryForChannel = async (channelId, sourceOfChange, isMliReset = false) => {
		const response = await this.service.updateInventoryForChannel(channelId, sourceOfChange, isMliReset);
		return response.data;
	};

	@action
	updateInventoryForAllChannelsAndProducts = async sourceOfChange => {
		const response = await this.service.updateInventory(sourceOfChange);
		return response.data;
	};
}

export default UpdateInventoryStore;



// WEBPACK FOOTER //
// ./src/modules/product/stores/UpdateInventoryStore.js